/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TasksCreateForm from 'DesignSystem/TasksCreateForm/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/CreateTaskAction/CreateTaskModal/Content/Content",
  onChange
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let letterValueData = fromData.useDataFormat({ viewPath,
context: 'letter',
format: fromHelpers.getAction,
})
let patientValueData = fromData.useDataValue({ viewPath,
context: 'patient',
})
let formValueData = fromData.useDataValue({ viewPath,
context: 'form',
})
let formChangeData = fromData.useDataChange({ viewPath,
context: 'form',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<TasksCreateForm
  viewPath={`${viewPath}/TasksCreateForm`}
 data="letter"
 format="helpers.js getAction"
 forceAction={letterValueData}
 data="patient"
 forcePatient={patientValueData}
 data="form"
 value={formValueData}
 onChange={formChangeData}
/>
</div>
{children}
</React.Fragment>)
}